module.exports = __webpack_public_path__ + "img/f958a9e.jpg";